import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import BootstrapTable from "src/components/BootstrapTable";
import DetailButton from "src/components/DetailButton";
import EditButton from "src/components/EditButton";
import Title from "src/components/Title";

const TagsOverviewSite = () => {
  const navigate = useNavigate();
  return (
    <React.Fragment>
      <Row>
        <Col>
          <Title>Tag-Übersicht</Title>
        </Col>
      </Row>

      <Row className="add-margin">
        <Col className="text-end">
          <Button variant="default" onClick={() => navigate(`/tag/add`)}>
            Neuer Tag
          </Button>
        </Col>
      </Row>
      <Row>
        <Col>
          <BootstrapTable
            url="/api/backend/tags"
            sort="name"
            order="asc"
            showSearch
            showClear
            showRefresh
            pageSize={25}
            pageSizes={[25, 50, 100, 250]}
            columns={[
              {
                field: "name",
                name: "Name",
                sortable: true,
              },
              {
                field: "icon",
                name: "icon",
                sortable: true,
              },
              {
                field: "gui_order",
                name: "GUI-Reihenfolge",
                sortable: true,
              },
              {
                field: "id",
                textAlign: "right",
                width: 80,
                formatter: (value) => {
                  return (
                    <React.Fragment>
                      <DetailButton url={`/tag/${value}`} />{" "}
                      <EditButton url={`/tag/edit/${value}`} />
                    </React.Fragment>
                  );
                },
              },
            ]}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default TagsOverviewSite;
